import type { components } from '@pba/types-openapi-node';

export type NodeOrganization = {
  channelTags?: ChannelTag[];
  id: string;
  name: string;
  settings?: {
    allowCustomChannels?: boolean;
  };
};

type ChannelTag = {
  hashid: string;
  name: string;
};

export const createNodeOrganization = (data: components['schemas']['Organization']): NodeOrganization => ({
  channelTags: data.channelTags,
  id: data._id,
  name: data.name,
  settings: data.settings,
});
